import { render, staticRenderFns } from "./NinaCardFront.vue?vue&type=template&id=0e3ccb9a&"
import script from "./NinaCardFront.vue?vue&type=script&lang=js&"
export * from "./NinaCardFront.vue?vue&type=script&lang=js&"
import style0 from "./NinaCardFront.vue?vue&type=style&index=0&id=0e3ccb9a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports